'use strict';

var _extends = require('../../../node_modules/@babel/runtime/helpers/extends.js');
var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
require('prop-types');
var Button = require('./Button/Button.js');
var Grid = require('../../Layout/Grid/Grid.js');
var Card = require('../../Surfaces/Cards/Card.js');
var CardContent = require('../../Surfaces/Cards/CardContent.js');
var makeStyles = require('../../Styles/makeStyles.js');
var classNames = require('classnames');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var useStyles = makeStyles["default"](function (theme) {
  return {
    button: {
      height: '100%',
      border: 'none',
      borderRadius: '8px !important',
      background: 'none',
      padding: 0,
      '&:hover': {
        background: 'none'
      }
    },
    buttonRoot: {
      textTransform: 'none'
    },
    wrapper: {
      height: '100%',
      width: '100%',
      border: '1.5px solid #fff',
      cursor: 'pointer',
      '&:hover': {
        border: "1.5px solid ".concat(theme.palette.primary.main),
        background: theme.palette.action.hover
      },
      '&::-webkit-transition': {
        transition: 'all .5s'
      },
      transition: 'all .5s',
      transitionTimingFunction: 'ease-in-out'
    },
    iconPlacement: {
      height: '100%'
    }
  };
});

var SolidCardButton = function SolidCardButton(_ref) {
  var children = _ref.children,
      icon = _ref.icon,
      onClick = _ref.onClick,
      classes = _ref.classes,
      cardStyle = _ref.cardStyle,
      restOfProps = objectWithoutProperties(_ref, ["children", "icon", "onClick", "classes", "cardStyle"]);

  var _useStyles = useStyles(),
      button = _useStyles.button,
      buttonRoot = _useStyles.buttonRoot,
      wrapper = _useStyles.wrapper,
      iconPlacement = _useStyles.iconPlacement;

  return React__default["default"].createElement(Button["default"], _extends["default"]({
    classes: _objectSpread({
      root: buttonRoot
    }, classes),
    fullWidth: true,
    onClick: onClick,
    className: button
  }, restOfProps), React__default["default"].createElement(Card, {
    className: classNames__default["default"](wrapper, cardStyle)
  }, React__default["default"].createElement(CardContent, null, React__default["default"].createElement(Grid, {
    container: true
  }, React__default["default"].createElement(Grid, {
    item: true,
    xs: icon ? 11 : 12
  }, children), icon && React__default["default"].createElement(Grid, {
    item: true,
    xs: 1
  }, React__default["default"].createElement(Grid, {
    container: true,
    alignItems: "center",
    justify: "flex-end",
    className: iconPlacement
  }, icon))))));
};

SolidCardButton.defaultProps = {
  onClick: function onClick() {}
};

module.exports = SolidCardButton;
